import { Text } from '@mantine/core'
import { useSiteContent } from '@/hooks/useSiteContent'
import styles from './InviteContent.module.css'

/**
 * Shared invitation description text used in the guest invitation view
 * and as the basis for printed cards.
 *
 * NOTE: This component loads content from database.
 */
export function InviteContent() {
  const { content } = useSiteContent()

  return (
    <Text ta="center" size="md" className={`${styles.root} ${styles.initialCapContainer}`}>
      {content?.invitation.storyText || ''}
    </Text>
  )
}
